import { ErrorAlert } from "components/alerts/ErrorAlert"
import { LoadingAlert } from "components/alerts/LoadingAlert"
import { SuccessAlert } from "components/alerts/Success"
import { DateInput } from "components/inputs/date/Date"
import { SelectField } from "components/inputs/select/Select"
import { TextAreaPersonalized } from "components/inputs/textAreaPersonalized/TextAreaPersonalized"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import { createNotice, editNotice } from "services/managerNotices/managerNotices"
import { dayIsGreaterThanToday } from "utils/dates"

export const AddEditManagerModal = (props: {
  show: boolean
  onHide: () => void
  object: {
    dataExpiracao: dayjs.Dayjs,
    tipo: "AVISO" | "ALERTA" | "COMUNICADO" | "PROMOÇÃO" | "",
    mensagem: string
    expirado?: boolean
    objectId?: string
  } | undefined
}) => {

  const [state, setState] = useState<{
    dataExpiracao: dayjs.Dayjs,
    tipo: "AVISO" | "ALERTA" | "COMUNICADO" | "PROMOÇÃO" | "",
    mensagem: string,
    expirado?: boolean
  }>({
    dataExpiracao: props.object ? dayjs(props.object.dataExpiracao) : dayjs(),
    tipo: props.object ? props.object.tipo : "",
    mensagem: props.object ? props.object.mensagem : "",
    expirado: props.object ? props.object.expirado : false
  })

  useEffect(() => {
    if (props.object) {
      setState({
        dataExpiracao: dayjs(props.object.dataExpiracao),
        tipo: props.object.tipo,
        mensagem: props.object.mensagem,
        expirado: props.object.expirado
      })
    }
  }, [])
  const options = [
    { label: "AVISO", value: "AVISO" },
    { label: "ALERTA", value: "ALERTA" },
    { label: "COMUNICADO", value: "COMUNICADO" },
    { label: "PROMOÇÃO", value: "PROMOÇÃO" },
  ]

  const handleSaveEdit = async () => {
    if (state.tipo === "" || state.mensagem === "") {
      ErrorAlert({ message: `Verifique se o campo de ${!state.mensagem ? "mensagem" : "tipo"} foi preenchido` })
      return
    }
    LoadingAlert({ show: true })
    const params = {
      dataExpiracao: (state.dataExpiracao).format("YYYY-MM-DD"),
      tipo: state.tipo,
      mensagem: state.mensagem,
    }
    try {
      if (props.object) {
        const expirado = dayIsGreaterThanToday(state.dataExpiracao)
        await editNotice({ ...params, objectId: props.object.objectId, expirado: !expirado })
      } else {
        await createNotice({ ...params })
      }
      SuccessAlert({ message: `Aviso ${props.object ? "editado" : "criado"} com sucesso!` })
    } catch (e: any) {
      ErrorAlert({ message: e.response.data.message })
    }
    props.onHide()
  }
  return (
    <Modal
      show={props.show}
      centered
      size='lg'
      onHide={props.onHide}

    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.object ? "Editar" : "Adicionar"} Aviso
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row mb-3 d-flex flex-column flex-md-row align-items-center'>
          <div className='col-12 col-sm-6 mb-3 mb-sm-0'>
            <SelectField
              placeholder ="Selecione o tipo"
            id='tipo'
            label='Tipo'
            options={options}
            required
            setState={setState}
            state={state}
            name='tipo'
            />
          </div>
          <div className='col-12 col-md-6'>
            <DateInput
              id='dataExpiracao'
              label='Data de expiração'
              setState={setState}
              state={state}
              required
              name='dataExpiracao'
            />
          </div>
        </div>

        <TextAreaPersonalized
          setState={setState}
          state={state}
          id='mensagem'
          placeholder='Escreva o aviso aqui...'
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='success' onClick={handleSaveEdit}>{props.object ? "Editar" : "Adicionar"}</Button>
        <Button variant='danger' onClick={props.onHide}>Fechar</Button>
      </Modal.Footer>
    </Modal>

  )
}